import type { NormalisedRequestFilterSet } from '@onhandtech/onhand-fe-shared/lib/api/v5/request-filter-set/request-filter-set.types'
import { formatEndpoint } from '@onhandtech/onhand-fe-shared/lib/request'
import { getConfig } from 'config/configuration'
import { patchRequestFilterSets } from 'redux/redux-modules'
import { put, select } from 'redux-saga/effects'

import type { SectionFilterType } from '../sections.types'
import { draftFiltersSelector, selectedSectionSelector } from '../selectors'

export function* saveSectionSaga() {
  const selectedSection: NormalisedRequestFilterSet | null = yield select(selectedSectionSelector)
  const draftFilters: SectionFilterType[] = yield select(draftFiltersSelector)

  if (selectedSection) {
    yield put(
      patchRequestFilterSets.actions.makeRequest({
        url: formatEndpoint(getConfig().endpoints.api.v5.patchRequestFilterSet, {
          id: selectedSection.id,
        }),
        payload: {
          request_filters: draftFilters.map(({ filter, type }) => ({
            request_id: type === 'action' ? filter.id : undefined,
            task_type_id: type === 'task-type' ? filter.id : undefined,
          })),
          name: selectedSection.name,
        },
      }),
    )
  }
}
